import React from 'react';
import { setTitle } from "../../../helpers/MetaTag";
import PlaceOrderContent from "../../../components/sections/front/User/PlaceOrderContent";


const PlaceOrder = () => {
  setTitle("Memory Doddle | Place Order");
  return (
    <>
      <section className="relative space-y-5">
        <div className="relative w-full sm:px-0 max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <PlaceOrderContent />
        </div>
      </section>
    </>
  );
};



export default PlaceOrder;
